import * as CONSTANTS from '../constants/actions/table';

/**
 * @name updateWidth
 * @function 
 * @description Updates the width of the table
 */
export const updateWidth = width => {
    return dispatch => dispatch({ type: CONSTANTS.UPDATE_WIDTH, payload: { width } });
}